export default {
    data() {
        return {
            filters: {},
            filtersReady: true
        };
    },
    created() {
        this.initFiltersFromUrl();
    },
    methods: {
        initFiltersFromUrl() {
            const query = this.$route.query;
            let filters = {};
            if (query.filter) {
                try { filters = JSON.parse(query.filter); }
                catch (e) { filters = {}; }
            }
            if (!filters.period) {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
                
                filters.period = {
                    start: `${year}-${month}-01`,
                    end:   `${year}-${month}-${String(lastDay).padStart(2, '0')}`
                };
            }
            this.filters = filters;
        },
        updateFilters(newFilters) {
            const before = JSON.stringify(this.filters);
            this.filters = { ...newFilters };
            if (JSON.stringify(this.filters) !== before) {
                this.syncFiltersToUrl();
            }
        },
        syncFiltersToUrl() {
            this.$nextTick(() => {
                const query = { ...this.$route.query };
                if (Object.keys(this.filters).length > 0) {
                    query.filter = JSON.stringify(this.filters);
                } else {
                    delete query.filter;
                }
                this.$router.replace({ query }).catch(() => {});
            });
        }
    }
};
